<template>
  <section class="container flex flex-col w-full md:w-2/3 text-center pb-7">
    <section class="mb-7">
      <FaIcon
        name="comments"
        variant="light"
        size="5x"
      />
      <p class="text-lg mt-5">
        {{ duzen('Du hast', 'Sie haben') }} Fragen, Anmerkungen, Wünsche oder Kritik?
      </p>
      <ElFormItem
        label="Anmerkungen:"
        for="anmerkungen"
        :error="formErrors.anmerkungen?.[0]"
        label-position="top"
      >
        <ElInput
          id="anmerkungen"
          v-model="form.anmerkungen"
          type="textarea"
          :rows="7"
        />
      </ElFormItem>
    </section>
    <section class="flex flex-col items-center mb-7">
      <div class="flex flex-row justify-center items-center gap-2 flex-wrap">
        <div
          id="formError.hatAgbZugestimmt"
          class="flex flex-row items-center gap-2"
        >
          <!-- `mr-0`: EPs 30px Außenabstand trennt Checkboxen in einer Gruppe,
               hier steht das Label daneben und der Abstand kommt aus `gap-2`. -->
          <ElCheckbox
            id="hatAgbZugestimmt"
            v-model="form.hatAgbZugestimmt"
            class="mr-0"
          />
          <label
            class="text-sm sm:text-base text-start inline-block"
            for="hatAgbZugestimmt"
          >
            Ich stimme der <a
              href="#"
              @click.prevent="showDatenschutz = true"
            >Datenschutzerklärung</a> zu.
          </label><br>
        </div>
      </div>
      <FieldError
        v-for="error in formErrors.hatAgbZugestimmt"
        :key="error"
      >
        {{ error }}
      </FieldError>
    </section>

    <BaseModal
      :show="showDatenschutz"
      height="85%"
      title="Datenschutz"
      @close="showDatenschutz = false"
    >
      <PrivacyText />
    </BaseModal>

    <BrokerContact />
  </section>
</template>

<script setup lang="ts">
import FaIcon from '@/application/components/ui/FaIcon.vue';
import FieldError from '@/application/components/ui/FieldError.vue';
import { ElCheckbox, ElFormItem, ElInput } from 'element-plus';
import BrokerContact from '@/checkup/components/BrokerContact.vue';
import PrivacyText from "@/legal/components/PrivacyText.vue";
import { useStep } from '@/checkup/state';
import { Step } from '@/checkup/utils/steps';
import { ref } from 'vue';
import { useBaseDataStore } from '@/user/store/baseDataStore.ts';
import BaseModal from '@/application/components/BaseModal.vue';

const { form, formErrors } = useStep(Step.ABSCHLUSS);
const { duzen } = useBaseDataStore();
const showDatenschutz = ref(false);
</script>
